module.exports = __webpack_public_path__ + "media/images/indicators/intensa-6a8abd10f555d62ffc3f956f38cd3523.png";